module.exports = __webpack_public_path__ + "static/img/perecent5.e2aaf7bd.png";